import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import exif from 'exif-js';

import { supportsFileLoad } from '../helpers/browser';

const resizeImageFile = (file, dataUrl, maxWidth) =>
  new Promise((resolve) => {
    exif.getData({ src: dataUrl }, function getExifData() {
      const orientation = this.exifdata.Orientation;
      const img = new Image();
      img.src = dataUrl;

      img.onload = () => {
        let width = img.width;
        let height = img.height;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const aspectRatio = width / height;

        if (img.width > maxWidth) {
          width = maxWidth;
          height = width / aspectRatio;
        }

        // set proper canvas dimensions before transform & export
        if (orientation > 4 && orientation < 9) {
          canvas.width = height;
          canvas.height = width;
        } else {
          canvas.width = width;
          canvas.height = height;
        }

        // transform context before drawing image
        switch (orientation) {
          case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
          case 3: ctx.transform(-1, 0, 0, -1, width, height); break;
          case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
          case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
          case 6: ctx.transform(0, 1, -1, 0, height, 0); break;
          case 7: ctx.transform(0, -1, -1, 0, height, width); break;
          case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
          default: break;
        }

        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob((blob) => {
          resolve({
            file: new File([blob], file.name, { type: file.type }),
            dataUrl: canvas.toDataURL(),
          });
        }, file.type);
      };
    });
  });

const withLoadImage = compose(
  branch(() => !supportsFileLoad, renderNothing),
  withState('fileContents', 'setFileContents', ''),
  withState('loading', 'setLoading', false),
  withHandlers({
    loadAndResizeImage: props => (imageFile, maxWidth) =>
    new Promise((resolve, reject) => {
      if (!imageFile) return reject();
      props.setLoading(true);

      const reader = new FileReader();

      reader.onloadend = () => {
        resizeImageFile(imageFile, reader.result, maxWidth)
          .then(({ dataUrl, file }) => {
            props.setFileContents(dataUrl);
            props.setLoading(false);
            return resolve(file);
          });
      };

      return reader.readAsDataURL(imageFile);
    }),
  })
);

export default withLoadImage;
